import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { BRAND } from '../../config/brand';
import { formatAccessDateTime } from './formatAccessDateTime';

/**
 * Header ve şube yöneticisi ödeme pencerelerinin üstündeki mobil abonelik özeti.
 * Tahsilat kaydı akışından bağımsızdır; durum AuthContext'ten okunur.
 */
const MobileSubscriptionInfo: React.FC = () => {
  const { t, i18n } = useTranslation();
  const {
    subscriptionUntil,
    subscriptionSource,
    subscriptionAutoRenewing,
    demoCarryOverDays,
    demoUntil,
    accessSource,
  } = useAuth();

  const storeLabel = subscriptionSource === 'google_play'
    ? t('accessLock.storeGoogle')
    : subscriptionSource === 'app_store'
      ? t('accessLock.storeApple')
      : null;

  if (subscriptionUntil) {
    const endLabel = formatAccessDateTime(subscriptionUntil, i18n.language);
    return (
      <Box
        sx={{
          mb: 2,
          p: 1.5,
          border: '1px solid',
          borderColor: 'primary.light',
          borderRadius: 1.5,
          bgcolor: 'rgba(25, 118, 210, 0.04)',
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.75 }}>
          <PhoneIphoneIcon fontSize="small" color="primary" />
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            {t('accessLock.mobileSection')}
          </Typography>
        </Stack>
        <Typography variant="body2">{t('accessLock.mobilePaid30')}</Typography>
        {demoCarryOverDays != null && demoCarryOverDays > 0 && (
          <Typography variant="body2">
            {t('accessLock.demoCarryOver', { count: demoCarryOverDays })}
          </Typography>
        )}
        {demoCarryOverDays === 0 && (
          <Typography variant="body2">{t('accessLock.demoUsed')}</Typography>
        )}
        {endLabel && (
          <Typography variant="body2">{t('accessLock.subscriptionEnds', { date: endLabel })}</Typography>
        )}
        {storeLabel && <Typography variant="body2">{storeLabel}</Typography>}
        {subscriptionAutoRenewing === true && (
          <Typography variant="body2">{t('accessLock.autoRenewOn')}</Typography>
        )}
        {subscriptionAutoRenewing === false && (
          <Typography variant="body2">{t('accessLock.autoRenewOff')}</Typography>
        )}
      </Box>
    );
  }

  if (demoUntil || accessSource === 'demo') {
    return (
      <Box
        sx={{
          mb: 2,
          p: 1.5,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1.5,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.75 }}>
          <PhoneIphoneIcon fontSize="small" color="primary" />
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            {t('accessLock.mobileSection')}
          </Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {t('accessLock.demoUpsell', { brand: BRAND.copyrightHolder })}
        </Typography>
      </Box>
    );
  }

  return null;
};

export default MobileSubscriptionInfo;
